'use strict';

angular.module('app.deleteAccount', [])
	.controller('deleteAccountCtrl', ['$scope', '$modal', '$modalInstance', 'deleteAccountService',
		function ($scope, $modal, $modalInstance, deleteAccountService) {

		    $scope.confirmDeleteAccount = function () {
		    	deleteAccountService.deleteAccount($scope.index.id, true)
		    		.then(function(responseDeleteAccount) {
		    			$scope.closeModal();
		            	$scope.preLoadData();
		    		}, function(responseDeleteAccount) {
		    			var errorModalInstance = $modal.open({
		                    scope: $scope,
		                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                    windowClass: 'modal-dialog-mention-error'
		                });
		                $scope.errorModalInstance = errorModalInstance;
		                $scope.errorMessage = responseDeleteAccount.message;
		    		})
		    }

		    $scope.closeModal = function () {
		         $modalInstance.close();
		    }
    
}])


